import { createContext } from 'react'

const LoadingContext = createContext(false)

export default LoadingContext
